import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import AlertBadge from '@/components/AlertBadge/AlertBadge';

import styles from './TransactionAlertsTableHeader.module.sass';

interface TransactionAlertsTableHeaderInterface {
  isScrolled?: boolean;
}

export const TransactionAlertsTableHeader = ({
  isScrolled = false,
}: TransactionAlertsTableHeaderInterface) => {
  const { t } = useTranslation();

  const classes = cx(styles.header, {
    [styles['is-scrolled']]: isScrolled,
  });

  return (
    <div className={classes}>
      <div className={styles.category}>{t('translation.category')}</div>
      <div className={styles.items}>
        <div className={styles.title}>{t('translation.alert_grade')}</div>
        <div className={styles.cols}>
          <div className={styles.col}>
            <AlertBadge type="low" />
          </div>

          <div className={styles.col}>
            <AlertBadge type="medium" />
          </div>

          <div className={styles.col}>
            <AlertBadge type="high" />
          </div>

          <div className={styles.col}>
            <AlertBadge type="severe" />
          </div>

          <div className={styles.actions} />
        </div>
      </div>
    </div>
  );
};
